import { StatusBadge } from '@/components/common/StatusBadge';
import type { StatusColorTone } from '@/styles/statusColors';
import { ACTIVITY_STATUS_LABELS, type ActivityStatus } from '../constants/moTravel.constants';

const ACTIVITY_STATUS_TONE: Record<ActivityStatus, StatusColorTone> = {
  ACTIVE: 'success',
  IDLE: 'warning',
  SUBMITTED: 'info',
  NO_LOCATION: 'neutral',
};

interface MoActivityStatusBadgeProps {
  status: ActivityStatus;
}

export function MoActivityStatusBadge({ status }: MoActivityStatusBadgeProps) {
  return (
    <StatusBadge tone={ACTIVITY_STATUS_TONE[status]}>{ACTIVITY_STATUS_LABELS[status]}</StatusBadge>
  );
}
